export const API_BASE_URL = "https://your-api-url.com/";
export const RESPONSE_STATUS = {
  DONE: "done!",
};
